<template>
    <div class="header">
        <div class="container">
          <a href="/"><img src="../assets/logo.png" alt="" class="logo"></a>
          <nav style="padding-right: 200px;padding-top: 5px">
            <ul>
              <router-link to="/">
                <li :class="this.$route.path==='/'? 'menu-active':'' ">Home</li>
              </router-link>
              <router-link to="/aboutUs">
                <li :class="this.$route.path==='/aboutUs'? 'menu-active':'' ">About us</li>
              </router-link>
              <router-link to="/products">
                <el-dropdown placement="bottom-start">
                  <li :class="this.$route.path.startsWith('/products')? 'menu-active':'' ">Products</li>
                  <el-dropdown-menu slot="dropdown">
                    <router-link v-for="item in productCategorys" :key="item.productCategoryId" :to="{path:item.productCategoryRouter, query:{productCategoryId:item.productCategoryId}}">
                      <el-dropdown-item>{{item.productCategoryMenu}}</el-dropdown-item>
                    </router-link>
                  </el-dropdown-menu>
                </el-dropdown>
              </router-link>
              <router-link to="/news">
                <li :class="this.$route.path.startsWith('/news')? 'menu-active':'' ">News</li>
              </router-link>
              <router-link to="/service">
                <li :class="this.$route.path==='/service'? 'menu-active':'' ">Service</li>
              </router-link>
              <router-link to="/contactUs">
                <li :class="this.$route.path==='/contactUs'? 'menu-active':'' ">Contact us</li>
              </router-link>
            </ul>
          </nav>
        </div>
    </div>
</template>
<script>
export default {
  name: "hearder",
    data() {
        return {
          productCategorys: []
        }
    },
    methods: {
      handleSelectMenu(cmd) {
        this.$router.push(cmd);
      },
      initCategorys() {
        let url = '/product/listCategory';
        this.getRequest(url).then(resp => {
          if (resp) {
            this.productCategorys = resp.data;
          }
        });
      }
    },
  mounted() {
    this.initCategorys();
  },
}
</script>
<style src="../assets/css/hearder.css" scoped>
</style>
